<template>
  <a-modal
    :title="title"
    centered
    :width="500"
    :mask-closable="false"
    :visible="showCreateBudgetForm"
    :confirmLoading="loading"
    @cancel="close"
  >
    <a-form-model
      ref="form"
      :model="model"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      >
        <a-spin :spinning="loading">
          <template>
            <a-form-model-item label="预算" prop="budget" help="预算值，取值范围：1000～9999999.99">
              <a-input-number :min="1000" :max="9999999.99" :precision="2" v-model="model.budget" style="width:300px"/>
            </a-form-model-item>
          </template>

        </a-spin>
      </a-form-model>

    <template slot="footer">
      <a-button @click="close" :disabled="loading">取消</a-button>
      <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
    </template>
  </a-modal>
</template>

<style lang="less" scoped>
@import 'CreateBudget';
</style>

<script>
import CreateBudget from './CreateBudget'
export default CreateBudget
</script>
